import { createBrowserConfig } from '@cian/config/browser';
import * as React from 'react';
import { render } from 'react-dom';

import { Deal, IPhone, IPhoto } from '../../../api/offer';

import {
  ISerpObjectPhoneOpenEvent,
  ISerpObjectPhoneOpenProduct,
  trackingSerpChangeConditions,
  trackingSerpObjectDetailOpen,
  trackingSerpOfferDetailOpen,
} from '../tracking';

import SerpPhotoGallery from '../../common/components/serp_photo_gallery/serp_photo_gallery';
import BSCSerpPhoneShow from '../components/bsc_serp_phone_show/bsc_serp_phone_show';
import BSCSerpSubscriptionForm from '../components/bsc_serp_subscription_form/bsc_serp_subscription_form';
import MapWithToggle from '../components/map_with_toggle/map_with_toggle';

import BSCAddRequest from '../components/bsc_add_request/bsc_add_request';

interface ISerpItem {
  trackingData: ISerpObjectPhoneOpenEvent;
  trackingProduct?: ISerpObjectPhoneOpenProduct;
  phones?: IPhone[];
  coordinates?: [number, number];
  photos?: IPhoto[];
  dealType: Deal;
  qs: string;
  phoneStatisticToken?: string;
}

const query = (node: HTMLElement, selector: string) => {
  const res = node.querySelector(selector);

  if (res) {
    return res as HTMLElement;
  }
  return undefined;
};

const queryAll = (node: HTMLElement, selector: string) => {
  const res = node.querySelectorAll(selector);

  if (res.length) {
    return res as NodeListOf<HTMLElement>;
  }
  return undefined;
};

const insertAfter = (newNode: HTMLElement, existingNode: HTMLElement) => {
  if (existingNode.nextElementSibling) {
    existingNode.parentElement.insertBefore(newNode, existingNode.nextElementSibling);
  } else {
    existingNode.parentElement.appendChild(newNode);
  }
};

interface IBootstrapBSCSerpMetricsProps {
  changeConditionsButton: HTMLElement;
  trackingData: {
    listingType: 'BC' | 'TC' | 'WC';
  };
}

function bootstrapBSCSerpMetrics({
  changeConditionsButton,
  trackingData,
}: IBootstrapBSCSerpMetricsProps) {
  changeConditionsButton.addEventListener('click', () => trackingSerpChangeConditions(trackingData));
}

function bootstrapBSCAddRequest(elem: HTMLElement) {
  render(<BSCAddRequest/>, elem);
}

function bootstrapBSCSerpItemDOM(node: HTMLElement, id: number, data: ISerpItem) {
  const { phones, coordinates, photos, phoneStatisticToken, trackingData, trackingProduct, dealType, qs } = data;
  const { bsCenterId, bsCenterType } = trackingData;
  const phonesNode = query(node, '[data-render-phones]');
  let mapNode: HTMLElement;
  const mapToggleNode = query(node, '[data-render-map-toggle]');
  const subscriptionFormNode = query(node, '[data-render-subscription-form]');
  const photosNode = query(node, '[data-render-photo-gallery]');
  const detailLinks = queryAll(node, '[data-detail-link]');
  const offersLinks = queryAll(node, '[data-offers-link]');

  const config = createBrowserConfig({ settingsKey: 'business_shopping_centers-list-monolith-frontend' });

  const ymapsUrl = config.get<string>('yandex.browser.ymaps_url');
  const ymapsKey = config.get<string>('yandex.browser.ymaps_key');
  const ymapsSuggestKey = config.get<string>('yandex.browser.ymaps_suggest_key');

  if (Array.isArray(phones) && phones.length && phonesNode) {
    render(<BSCSerpPhoneShow
      id={id}
      phones={phones}
      trackingData={trackingData}
      trackingProduct={trackingProduct}
      phoneStatisticToken={phoneStatisticToken}
    />, phonesNode);
  }

  if (Array.isArray(photos) && photos.length && photosNode) {
    render(<SerpPhotoGallery photos={photos}/>, photosNode);
    setTimeout(() => { photosNode.style.backgroundImage = null; }, 1000);
  }

  if (Array.isArray(coordinates) && coordinates.length && mapToggleNode) {
    mapNode = document.createElement('div');
    mapNode.className = 'cf-bsc-list-map';

    insertAfter(mapNode, node);

    let map: MapWithToggle;

    render(
      <MapWithToggle
        coordinates={coordinates}
        mapNode={mapNode}
        ref={ref => map = ref}
        ymapsUrlWithKey={`${ymapsUrl}${ymapsKey}&suggest_apikey=${ymapsSuggestKey}`}
      />,
      mapToggleNode
    );
  }

  if (detailLinks && detailLinks.length) {
    Array.from(detailLinks).forEach((link) => {
      const getTrackingData = () => ({
        action: link.getAttribute('data-analytics-action'),
        bsCenterId,
        listingType: bsCenterType,
        trackingProduct,
      });

      link.addEventListener('click', () => {
        trackingSerpObjectDetailOpen(getTrackingData());
      });

      link.addEventListener('auxclick', (e: MouseEvent) => {
        if (e.button === 1) {
          trackingSerpObjectDetailOpen(getTrackingData());
        }
      });
    });
  }

  if (offersLinks && offersLinks.length) {
    Array.from(offersLinks).forEach((el) => el.addEventListener('click', () => trackingSerpOfferDetailOpen({
      offerId: Number(el.getAttribute('data-offer-id')),
      listingType: bsCenterType,
    })));
  }

  if (subscriptionFormNode) {
    render(
      <BSCSerpSubscriptionForm
        {...{dealType, qs}}
      />, subscriptionFormNode
    );
  }
}

export {
  ISerpItem,
  bootstrapBSCSerpItemDOM,
  bootstrapBSCSerpMetrics,
  bootstrapBSCAddRequest
}



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/utils/bootstrap_serp_dom.tsx